import { render, staticRenderFns } from "./Paymentstart.vue?vue&type=template&id=3e2e42fe&scoped=true"
import script from "./Paymentstart.vue?vue&type=script&lang=js"
export * from "./Paymentstart.vue?vue&type=script&lang=js"
import style0 from "./Paymentstart.vue?vue&type=style&index=0&id=3e2e42fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2e42fe",
  null
  
)

export default component.exports